module.exports = __webpack_public_path__ + "img/logo_w_s@2x.6dd2f080.png";